import { Toaster } from "react-hot-toast"
import { Helmet } from "react-helmet-async"
import { TooltipProvider } from "./components/ui/Tooltip/AppTooltip"
import Routers from "./router/Routes"

/** Matches develop `.env` default; override per env with REACT_APP_TITLE at build time. */
const APP_DOCUMENT_TITLE = process.env.REACT_APP_TITLE || "LocumScope ™"

// Apply saved theme immediately before first render to avoid flash
const VALID_THEMES = ['light', 'dark'];
const savedTheme = localStorage.getItem('app-theme');
if (savedTheme && VALID_THEMES.includes(savedTheme) && savedTheme !== 'light') {
  document.documentElement.dataset.theme = savedTheme;
}

// Note: theme Redux sync lives in ThemeSync (inside the Provider in Routes.js)

function App() {
  return (
    <TooltipProvider>
      <Helmet defaultTitle={APP_DOCUMENT_TITLE}>
        <title>{APP_DOCUMENT_TITLE}</title>
      </Helmet>
      <Routers />
      <Toaster position="top-right" />
    </TooltipProvider>
  )
}

export default App;
